<template>
  <div class="wrapBox">
    <div class="top">
      <el-button type="primary" @click.native="goback">返回</el-button>
    </div>
    <div class="son-wrap">
      <el-aside width="300px" style="height: auto">
        <el-row class="title" :gutter="20">
          <el-col :span="16">
            <div class="grid-content bg-purple">部门列表</div>
          </el-col>
        </el-row>
        <div>
          <div class="custom-tree-container">
            <div class="block">
              <el-tree
                :data="deptTreeData"
                show-checkbox
                node-key="id"
                ref="tree"
                default-expand-all
                highlight-current
                :expand-on-click-node="false"
              >
                <span class="custom-tree-node is-show" slot-scope="{ node }">
                  <span>{{ node.label }}</span>
                </span>
              </el-tree>
            </div>
          </div>
        </div>
      </el-aside>
      <el-container style="flex-direction: column">
        <div class="son-box">
          <el-form
            size="medium"
            :inline="true"
            :model="queryForm"
            ref="queryForm"
            @submit.native.prevent
          >
            <div
              style="
                padding: 20px;
                border: 2px solid #ebeef5;
                border-radius: 6px;
              "
            >
              <div>
                <el-form-item>
                  <date-picker
                    :startTime="startTime"
                    :endTime="endTime"
                    @changeStart="changeStart"
                    @changeEnd="changeEnd"
                  >
                  </date-picker>
                </el-form-item>
                <el-form-item class="r-10" prop="plateNum">
                  <el-input
                    v-model="queryForm.plateNum"
                    @keyup.enter.native="query"
                    placeholder="车牌号"
                  ></el-input>
                </el-form-item>
                <el-form-item class="r-10" prop="name">
                  <el-input
                    v-model="queryForm.name"
                    @keyup.enter.native="query"
                    placeholder="车辆绑定人"
                  ></el-input>
                </el-form-item>
              </div>
              <div>
                <el-checkbox-group v-model="queryForm.typeList" size="small">
                  <el-checkbox-button
                    v-for="typeItem in outlayAnalysisType"
                    :label="typeItem.code"
                    :key="typeItem.code"
                    >{{ typeItem.value }}</el-checkbox-button
                  >
                </el-checkbox-group>
              </div>
            </div>
            <div style="margin: 20px 0px">
              <el-button
                v-if="hasPerm('base:station:list')"
                type="primary"
                @click="query"
                >查询</el-button
              >
              <el-button v-if="hasPerm('base:station:list')" @click="reset"
                >取消</el-button
              >
              <el-button
                v-if="exportFile"
                type="primary"
                class="btn-width"
                @click="exportFileBtn"
                >导出</el-button
              >
            </div>
            <el-row
              v-if="showEcharts"
              style="
                padding: 20px 0px 20px 20px;
                border: 2px solid #ebeef5;
                border-radius: 6px;
                margin-bottom: 20px !important;
              "
            >
              <el-col :span="22">
                <el-col
                  v-for="item of typeCountList"
                  :key="item.type"
                  :span="7"
                  style="line-height: 28px"
                >
                  <template v-if="item.type == 6">
                    <el-col :span="15" style="text-align: right"
                      >{{ item.projectName }}：</el-col
                    >
                    <el-col :span="9">{{ item.valueTmp }}</el-col>
                  </template>
                  <template v-else>
                    <el-col :span="15" style="text-align: right"
                      >{{ item.projectName }}({{ item.unit }})：</el-col
                    >
                    <el-col :span="9">{{ item.value }}</el-col>
                  </template>
                </el-col>
              </el-col>
              <el-col :span="2" style="float: right"
                ><el-button type="primary" @click="getChartsData"
                  >数据统计图</el-button
                ></el-col
              >
            </el-row>
          </el-form>
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            max-height="450"
            size="mini"
            row-key="id"
            border
            default-expand-all
            :tree-props="{ children: 'children' }"
          >
            <el-table-column
              align="center"
              fixed="left"
              width="120"
              prop="plateNum"
              label="车牌号"
            ></el-table-column>
            <el-table-column
              align="center"
              fixed="left"
              width="130"
              show-overflow-tooltip
              prop="deptName"
              label="使用部门"
            ></el-table-column>
            <el-table-column
              align="center"
              fixed="left"
              min-width="150"
              show-overflow-tooltip
              prop="companyName"
              label="所属运维公司"
            ></el-table-column>
            <el-table-column
              align="center"
              fixed="left"
              width="130"
              show-overflow-tooltip
              prop="projectName"
              label="统计项目"
            ></el-table-column>
            <el-table-column
              align="center"
              width="70"
              v-for="(item, index) of tableDataTitle"
              :key="index"
              :label="item"
            >
              <template slot-scope="scope">{{
                scope.row.analysisCountNode[item]
              }}</template>
            </el-table-column>
            <el-table-column
              align="center"
              fixed="right"
              width="80"
              prop="total"
              label="合计"
            ></el-table-column>
          </el-table>
        </div>
      </el-container>
      <el-dialog
        title="数据统计图"
        :visible.sync="deiverVisible"
        width="950px"
        class="mini-dialog deiverBody"
      >
        <div
          class="imgWrap"
          style="
            padding-bottom: 10px;
            width: 100%;
            height: 650px;
            overflow-y: scroll;
          "
        >
          <el-row style="color: #000; font-weight: bold">{{
            monthrange
          }}</el-row>
          <el-row
            v-for="(item, index) of chartsData"
            :key="index"
            style="margin-top: 10px !important"
          >
            <el-row style="line-height: 30px; color: #000">{{
              item.projectName
            }}</el-row>
            <el-row
              style="
                width: 100%;
                height: 200px;
                border: 1px solid #000;
                padding: 10px;
              "
            >
              <el-col
                style="height: 100%"
                :span="12"
                :id="'bar' + index"
              ></el-col>
              <el-col
                style="height: 100%"
                :span="12"
                :id="'pie' + index"
              ></el-col>
            </el-row>
          </el-row>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import DatePicker from "@/components/DatePicker.vue";
export default {
  name: "ExpenseAnalyst",
  components: {
    DatePicker,
  },
  data() {
    return {
      showEcharts: false,
      deiverVisible: false,
      exportFile: false,
      myChart: "",
      chartsData: [],
      deptTreeData: [],
      queryForm: {
        startDate: "",
        endDate: "",
        typeList: [],
        deptId: "",
        plateNum: "",
        name: "",
      },
      tableDataTitle: [],
      outlayAnalysisType: [],
      startTime: "",
      endTime: "",
      monthrange: "",
      tableData: [],
      typeCountList: [],
    };
  },
  created() {
    this.getDeptList();
  },
  watch: {
    deptTreeData(val) {
      let _this = this;
      if (val) {
        this.show = true;
        this.$nextTick(() => {
          if (_this.queryForm.deptId == "") {
            document.querySelector(".el-tree-node__content").click();
          } else {
            _this.$refs.tree.setCurrentKey(_this.queryForm.deptId);
            // _this.getDeptInfon(_this.deptId)
            // _this.getUserList()
          }
        });
      }
    },
  },
  mounted() {
    this.getOutlayAnalysisType();
  },
  methods: {
    // 文件导出
    exportFileBtn() {
      let _this = this;
      let list = this.$refs.tree.getCheckedNodes();
      let arr = [];
      list.map((item) => {
        arr.push(item.id);
      });
      let url =
        "/api/outlay/manage/analysis/export?deptId=" +
        arr.toString() +
        "&typeList=" +
        _this.queryForm.typeList.toString() +
        "&plateNum=" +
        _this.queryForm.plateNum +
        "&name=" +
        _this.queryForm.name +
        "&startDate=" +
        _this.startTime.split(" ")[0] +
        "&endDate=" +
        _this.endTime.split(" ")[0];
      window.location.href = url;
    },
    initBarCharts(id, datax, datay, text, unit) {
      this.myChart = this.$echarts.init(document.getElementById(id));
      this.myChart.setOption({
        color: "#1074f6",
        title: {
          text: text + "排行",
          left: "left",
          textStyle: {
            color: "#000",
            fontStyle: "normal",
            fontWeight: "bold",
            fontFamily: "sans-serif",
            fontSize: 14,
          },
        },
        tooltip: {
          trigger: "axis",
          confine: true,
          formatter: function (params) {
            return params[0].data + unit;
          },
        },
        grid: {
          left: "1%",
          right: "10%",
          top: "12%",
          bottom: "-1%",
          containLabel: true,
        },
        xAxis: {
          name: unit,
          axisTick: {
            show: false, // 不显示坐标轴刻度线
          },
          splitLine: {
            show: false,
          },
          type: "value",
        },
        yAxis: {
          type: "category",
          data: datay,
        },
        series: [
          {
            data: datax,
            label: {
              position: "right",
              color: "#000",
              show: true,
            },
            type: "bar",
          },
        ],
      });
    },
    //随机生成十六进制颜色
    randomHexColor() {
      var hex = Math.floor(Math.random() * 16777216).toString(16); //生成ffffff以内16进制数
      while (hex.length < 6) {
        //while循环判断hex位数，少于6位前面加0凑够6位
        hex = "0" + hex;
      }
      return "#" + hex; //返回'#'开头16进制颜色
    },
    // 饼状图颜色设置
    setColor(pieData) {
      let colorList = [];
      for (let i = 0; i < pieData.length - 2; i++) {
        colorList.push(this.randomHexColor());
      }
      return colorList;
    },
    initPieCharts(id, pieData, text, unit) {
      this.myChart = this.$echarts.init(document.getElementById(id));
      this.myChart.setOption({
        color: [
          "#f7cb52",
          "#03c1d6",
          "#e59d4a",
          "#04d568",
          "#54c2e1",
          "#a380dd",
          "#1074f6",
          "#fc3ea8",
          "#1099f0",
          "#263c5c",
        ].concat(this.setColor(pieData)),
        title: {
          text: text + "占比",
          left: "left",
          textStyle: {
            color: "#000",
            fontStyle: "normal",
            fontWeight: "bold",
            fontFamily: "sans-serif",
            fontSize: 14,
          },
        },
        tooltip: {
          trigger: "item",
          confine: true,
        },
        series: [
          {
            name: text,
            type: "pie",
            radius: "50%",
            data: pieData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              formatter: "{b}:{c}" + unit,
              minMargin: 5,
              edgeDistance: 10,
              lineHeight: 15,
            },
          },
        ],
      });
    },
    // 获取费用分析数据图
    async getChartsData() {
      let _this = this;
      let list = this.$refs.tree.getCheckedNodes();
      if (list.length == 0) {
        _this.$message.error("请选择部门");
        return;
      }
      if (!_this.startTime || !_this.endTime) {
        _this.$message.error("请选择时间");
        return;
      }
      let arr = [];
      list.map((item) => {
        arr.push(item.id);
      });
      let startY = _this.startTime.split(" ")[0].split("-")[0];
      let startM = _this.startTime.split(" ")[0].split("-")[1];
      let endY = _this.endTime.split(" ")[0].split("-")[0];
      let endM = _this.endTime.split(" ")[0].split("-")[1];
      _this.monthrange =
        startY + "年" + startM + "月-" + endY + "年" + endM + "月";
      let obj = {
        startDate: _this.startTime.split(" ")[0],
        endDate: _this.endTime.split(" ")[0],
        deptId: arr.toString(),
        typeList: _this.queryForm.typeList.toString(),
        plateNum: _this.queryForm.plateNum,
        name: _this.queryForm.name,
      };
      let { data: res } = await _this.$axios.get(
        "/api/outlay/manage/analysis/chart",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        _this.chartsData = res.data;
        _this.deiverVisible = true;
        _this.chartsData.map((item, index) => {
          let datax = [];
          let datay = [];
          // if(item.projectName=='发电时长'){
          //   item.typeCountList.map(dataItem=>{
          //     return {
          //       name:dataItem.name,
          //       value:dataItem.value/60
          //     }
          //   })
          //   console.log(item)
          // }
          item.typeCountList.map((dataItem) => {
            datax.push(dataItem.value);
            datay.push(dataItem.name);
          });
          _this.$nextTick(() => {
            _this.initBarCharts(
              "bar" + index,
              datax,
              datay,
              item.projectName,
              item.unit
            );
            _this.initPieCharts(
              "pie" + index,
              item.typeCountList,
              item.projectName,
              item.unit
            );
          });
        });
      } else {
        _this.$message.warning(res.msg);
      }
    },
    goback() {
      this.$emit("goback");
    },
    changeStart(val) {
      this.startTime = val;
    },
    changeEnd(val) {
      this.endTime = val;
    },
    // 获取费用类型
    async getOutlayAnalysisType() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/sys/dict/outlayAnalysisType"
      );
      if (res.code == 1) {
        console.log(res.data);
        let showData = res.data.slice(0, 4);
        _this.outlayAnalysisType = showData;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 获取车辆分析表
    async getDepreciationList() {
      let _this = this;
      let list = this.$refs.tree.getCheckedNodes();
      if (list.length == 0) {
        _this.$message.error("请选择部门");
        return;
      }
      if (!_this.startTime || !_this.endTime) {
        _this.$message.error("请选择时间");
        return;
      }
      let arr = [];
      list.map((item) => {
        arr.push(item.id);
      });
      let obj = {
        startDate: _this.startTime.split(" ")[0],
        endDate: _this.endTime.split(" ")[0],
        deptId: arr.toString(),
        typeList: _this.queryForm.typeList.toString(),
        plateNum: _this.queryForm.plateNum,
        name: _this.queryForm.name,
      };
      let { data: res } = await _this.$axios.get(
        "/api/outlay/manage/analysis",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        _this.tableData = res.data.outlayAnalysisList;
        _this.tableDataTitle = res.data.titleList;
        _this.typeCountList = res.data.typeCountList;
        _this.exportFile = true;
        if (_this.typeCountList.length > 0) {
          _this.showEcharts = true;
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    async getDeptList() {
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/sys/dept/list");
      if (res.code == 1) {
        if (res.data.length == 0) {
          _this.queryForm.deptId = "";
        }
        _this.deptTreeData = res.data;
      } else {
        _this.queryForm.deptId = "";
        _this.$message.warning(res.msg);
      }
    },
    query() {
      this.getDepreciationList();
    },
    reset() {
      this.$resetForm(this, "queryForm");
      this.queryForm = {
        startDate: "",
        endDate: "",
        typeList: [],
        deptId: "",
        plateNum: "",
        name: "",
      };
      this.startTime = "";
      this.endTime = "";
      this.$refs.tree.setCheckedKeys([]);
      this.showEcharts = false;
      this.tableData = [];
      this.tableDataTitle = [];
      this.typeCountList = [];
      this.exportFile = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.son-wrap {
  display: flex;
  flex-direction: row;
  height: calc(100% - 42px);
}
.son-wrap .el-container {
  background-color: #fff;
  height: 100%;
}
.son-box {
  padding: 20px;
}
.wrapBox {
  width: 100%;
  height: calc(100% - 20px);
}
.top {
  margin-bottom: 10px;
}
/deep/ .el-table td,
/deep/ .el-table th.is-leaf {
  border: 1px solid #ebeef5;
}
/deep/ .el-checkbox-button {
  margin-right: 20px;
  .el-checkbox-button__inner {
    border-radius: 4px;
    border: 1px solid #dcdfe6;
  }
}
/deep/ .el-checkbox-button.is-checked .el-checkbox-button__inner {
  box-shadow: unset;
}
/deep/ .el-table td,
/deep/ .el-table--mini th {
  padding: 6px 0px;
}
/deep/ .el-table--border,
.el-table--group {
  border: none;
}
/deep/ .el-table--border::after,
/deep/ .el-table--group::after {
  height: fit-content;
}
</style>
